import { render, staticRenderFns } from "./mb-size-select.vue?vue&type=template&id=1a905e54&scoped=true&"
import script from "./mb-size-select.vue?vue&type=script&lang=ts&"
export * from "./mb-size-select.vue?vue&type=script&lang=ts&"
import style0 from "./mb-size-select.vue?vue&type=style&index=0&id=1a905e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a905e54",
  null
  
)

export default component.exports